import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import reportWebVitals from './reportWebVitals';
import {
  BrowserRouter,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import AuthProvider from './components/ContextHook';
import Header from './components/Header';
import ThemeContext from './hooks/ThemeContext';

const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);

root.render(
  <React.StrictMode>
    <BrowserRouter>
      <AuthProvider>
        <ThemeContext>
          <Header/>
          <Routes>
            <Route path="/premium" element={<App/>} />
            <Route path="*" element={<Navigate to="/premium" replace />} />
          </Routes>
        </ThemeContext>
      </AuthProvider>
    </BrowserRouter>
  </React.StrictMode>
);


reportWebVitals();
